import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { NumberOfPerPage } from "../utils/globalVariable";
import { formatDateDb, formatDateHourDb } from "../utils/tools";
import {
  customDateFormatType,
  formatDateForInput,
  formatNumber,
} from "../utils/utils";

const NUMBER_NFT_PER_PAGE = NumberOfPerPage.brokerDebtCertificateInLocking;
const queryKey = "brokerDebtCertificateInLocking";

async function fetchBrokerDebtCertificateInLocking(currentPage, param) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (param?.employeeId) options.employeeId = param.employeeId;

    if (param?.startTime)
      options.startTime = customDateFormatType(param.startTime);
    if (param?.endTime) options.endTime = customDateFormatType(param.endTime);

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI(
      "get",
      `/brokerDebtCertificate/locking?${queryParams}`,
    );
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries,
    );

    const newData = data?.items.map((item, index) => {
      return {
        id: item?.employeeId || "",
        lockingId: item?.lockingId || "",
        apartmentCode: item?.locking?.apartment?.code || "-",
        // Ngày tính toán = ngày TẠO bản ghi (khi PDV được tính ra), dùng createdAt.
        transactionDate: item?.createdAt
          ? formatDateHourDb(item?.createdAt, 1)
          : "-",
        // Ngày cập nhật = lần cuối bản ghi được sửa, dùng updatedAt.
        updatedDate: item?.updatedAt ? formatDateHourDb(item?.updatedAt, 1) : "-",
        certificateOrDeposit: item?.certificateOrDeposit
          ? `${formatNumber(item?.certificateOrDeposit)} VNĐ`
          : "0 VNĐ",
      };
    });

    return { data: newData, totalPages, entries, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useBrokerDebtCertificateInLocking(param) {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [queryKey, currentPage, param],
    queryFn: () => fetchBrokerDebtCertificateInLocking(currentPage, param),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    BrokerDebtCertificateInLockingListData: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
